(() => {
  const q = (selector, context = document) => context.querySelector(selector);
  const qa = (selector, context = document) => [...context.querySelectorAll(selector)];

  /* Keep the registered mark visually attached to prominent brand wordmarks. */
  qa('.wordmark, .footer-wordmark').forEach((link) => {
    if (q('.brand-mark__registered', link)) return;
    link.classList.add('brand-mark');
    const mark = document.createElement('span');
    mark.className = 'brand-mark__registered';
    mark.setAttribute('aria-hidden', 'true');
    mark.textContent = '®';
    link.appendChild(mark);
  });

  /* Normalize visible interface labels while leaving prose sentence case intact. */
  qa('.product-main [data-variant-picker] legend').forEach((legend) => {
    legend.textContent = legend.textContent.toLowerCase();
  });
  qa('.product-main--gift-card [data-variant-picker] label').forEach((label) => {
    label.textContent = label.textContent.toLowerCase();
  });

  /* Keep the gift-card dash attached to the brand name, not to "gift card". */
  const giftTitle = q('.product-main--gift-card .product-title-block h1');
  if (giftTitle && /clouds collective\s*-\s*gift card/i.test(giftTitle.textContent || '')) {
    giftTitle.textContent = '';
    const prefix = document.createElement('span');
    prefix.className = 'gift-card-title-prefix';
    prefix.textContent = 'clouds collective -';
    const tail = document.createElement('span');
    tail.className = 'gift-card-title-tail';
    tail.textContent = 'gift card';
    giftTitle.append(prefix, document.createTextNode(' '), tail);
  }

  /* Hide the cart quantity completely when the cart is empty. Theme.js keeps the text synced. */
  qa('[data-cart-count]').forEach((count) => {
    const syncVisibility = () => { count.hidden = Number.parseInt(count.textContent || '0', 10) <= 0; };
    new MutationObserver(syncVisibility).observe(count, { childList: true, characterData: true, subtree: true });
    syncVisibility();
  });

  /* Avoid a dead review link when the theme editor link has not been populated yet. */
  const reviewLink = q('.review-line');
  if (reviewLink) {
    const rawHref = reviewLink.getAttribute('href') || '';
    if (!rawHref || rawHref === window.location.pathname || rawHref === window.location.href) {
      reviewLink.href = 'https://www.google.com/maps/search/?api=1&query=Clouds%20Collective%20Antwerp';
      reviewLink.target = '_blank';
      reviewLink.rel = 'noopener noreferrer';
    }
  }

  /* Gift-card fulfilment note follows physical/digital selection. */
  const giftRoot = q('.product-main--gift-card');
  if (giftRoot) {
    const deliveryGroup = q('[data-gift-card-delivery-option]', giftRoot);
    const status = q('[data-product-status]', giftRoot);
    const updateGiftStatus = () => {
      if (!deliveryGroup || !status) return;
      const selected = q('input:checked', deliveryGroup)?.value?.toLowerCase() || '';
      status.textContent = selected === 'physical'
        ? (status.dataset.giftCardPhysicalText || 'physical gift cards are made to order. delivery is free in belgium and €14 elsewhere in europe.')
        : (status.dataset.giftCardText || 'valid online at clouds-collective.com');
    };
    deliveryGroup?.addEventListener('change', updateGiftStatus);
    updateGiftStatus();
  }

  /* Lightweight contact-form spam guard alongside Shopify's own challenge protection. */
  const contactForm = q('.contact-form');
  const honeypot = q('[data-contact-honeypot]');
  contactForm?.addEventListener('submit', (event) => {
    if (honeypot?.value) event.preventDefault();
  });

  /* Request a deliberately small Shopify CDN image for cart drawer thumbnails. */
  const resizeShopifyImage = (src, width = 180) => {
    if (!src) return '';
    try {
      const url = new URL(src, window.location.origin);
      if (!/cdn\.shopify\.com|shopifycdn\.net|\.myshopify\.com$/i.test(url.hostname) && !url.pathname.includes('/cdn/shop/')) return src;
      url.searchParams.set('width', String(width));
      return url.toString();
    } catch {
      return src;
    }
  };

  const drawer = q('[data-cart-drawer]');
  if (drawer) {
    const optimizeDrawerImages = () => {
      qa('[data-cart-items] img').forEach((image) => {
        const optimized = resizeShopifyImage(image.getAttribute('src'), 180);
        if (optimized && image.src !== optimized) image.src = optimized;
        image.width = 82;
        image.height = 82;
        image.loading = 'lazy';
        image.decoding = 'async';
      });
    };
    const observer = new MutationObserver(optimizeDrawerImages);
    observer.observe(q('[data-cart-items]', drawer) || drawer, { childList: true, subtree: true });
    optimizeDrawerImages();
  }

  /* Policy pages: the theme's page-main layout was vertically distributing short content. Force a normal document flow. */
  if (document.body.classList.contains('template-policy')) {
    const style = document.createElement('style');
    style.dataset.policyFlowFix = 'true';
    style.textContent = `
      .template-policy .page-main{display:block!important;min-height:0!important;height:auto!important}
      .template-policy .page-header{display:block!important;margin:0 0 30px!important;padding:0!important;min-height:0!important;height:auto!important}
      .template-policy .page-header h1{margin:0!important;padding:0!important}
      .template-policy .page-content{display:block!important;margin:0!important;padding:0!important;min-height:0!important;height:auto!important}
    `;
    document.head.appendChild(style);
  }
})();
